import React from 'react';

function Hello() {
    return (
        <div class="jumbotron">
            <h1 class="display-4">Welcome to the Cove</h1>
            <p class="lead">The Best Way for Narcs to Schedule Chores</p>
            <hr class="my-4"/>
            <p>Max asked me to make this app for him and I have nothing better to do so I guess this is going to happen.</p>
            <a class="btn btn-primary btn-lg" href="login" role="button">Thanks, Jakob.</a>
        </div>
    );
}

export default Hello;